<template>
    <div>
        <h1>Добавление объявления</h1>
        <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="Заголовок" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="Текст" prop="description">
                <el-input :rows="5" type="textarea" v-model="form.description"  maxlength="200" show-word-limit></el-input>
            </el-form-item>

            <el-form-item>
                <span style="color: #606266;">Дата окончания</span>
                <br>
                <el-input style="width: 227px" type="date" v-model="form.dateEnd" show-word-limit></el-input>
            </el-form-item>

            <el-form-item >
                <span style="color: #606266;">Цвет объявления</span>
                <br>
                <el-select v-model="form.color" placeholder="Выберите цвет"  style="width: 227px">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button @click="backRoute()">Назад</el-button>
                <el-button type="primary" @click="submitForm()">Сохранить</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            options: [
                {
                    value: 'white',
                    label: 'Белый'
                },
                {
                    value: 'yellow',
                    label: 'Желтый'
                },
                {
                    value: 'gray',
                    label: 'Серый'
                },
                {
                    value: 'blue',
                    label: 'Синий'
                },
            ],
            form: {
                color: 'white',
                title: '',
                description: '',
                dateEnd: ''
            },
            rules: {
                description: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    { min: 0, max: 200, message: 'Максимум 200 символов', trigger: 'blur' }
                ],
                title: [
                    { required: true, message: 'Поле не должно быть пустым', trigger: 'blur' },
                    { min: 0, max: 50, message: 'Максимум 50 символов', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        backRoute() {
            this.$router.push({path: '/announcement/'})
        },
        submitForm() {
            this.$refs.form.validate( async (valid) => {
                if (valid) {
                    try {
                        await this.$store.dispatch('announcementCreate', this.form)

                        this.$message({
                            message: 'Объявление добавлено',
                            type: 'success'
                        });

                        setTimeout(() => {
                            this.$router.push({path: '/announcement/'})
                        }, 1000);
                    } catch(e) {
                        this.$ErrorsMod(e)
                    }

                } else {
                    return false
                }
            })
        }
    }
}
</script>
